import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import createPlayer from './modues/player'
Vue.use(Vuex)

const STORAGE_KEY = 'cricket-darts-game'
const undoStates = []

let gameDefaults = {
  playing: false,
  game_over: false,
  numplayers: 2,
  maxnumplayer: 7,
  mode: 'standard',
  scoring: 'standard',
  all_numbers: [
    { key: 20, value: 0 },
    { key: 19, value: 0 },
    { key: 18, value: 0 },
    { key: 17, value: 0 },
    { key: 16, value: 0 },
    { key: 15, value: 0 },
    { key: 14, value: 0 },
    { key: 13, value: 0 },
    { key: 12, value: 0 },
    { key: 11, value: 0 },
    { key: 10, value: 0 },
    { key: 9, value: 0 },
    { key: 8, value: 0 },
    { key: 7, value: 0 }
  ],
  cricket_numbers: [
    { key: 20, value: 0 },
    { key: 19, value: 0 },
    { key: 18, value: 0 },
    { key: 17, value: 0 },
    { key: 16, value: 0 },
    { key: 15, value: 0 },
    { key: 25, value: 0 }
  ],
  scores: null,
  players: []
}

const state = {
  // game: JSON.parse(window.localStorage.getItem(STORAGE_KEY) || JSON.stringify(gameDefaults))
  game: JSON.parse(JSON.stringify(gameDefaults))
}

// getters
const getters = {
  getGameState: state => state.game,
  getGameStatus: state => state.game.game_over,
  getPlayers: state => state.game.players,
  getGameNumbers: state => state.game.numbers,
  getPlayerById: (state) => (id) => {
    return state.game.players.find(player => player.id === id)
  },
  getPlayerStrikesById: (state) => (id) => {
    return state.game.players.find(player => player.id === id).strikes
  },
  getPlayerScoreById: (state) => (id) => {
    return state.game.players.find(player => player.id === id).score
  }
}

const actions = {
  undo (context) {
    state.game.game_over = false
    context.commit('undo')
  },
  setPlayers (context) {
    const newPlayers = []
    var i
    for (i = 0; i < state.game.numplayers; i++) {
      if (newPlayers.length >= state.game.maxnumplayer) return
      const playerNumbers = _.cloneDeep(state.game.scores)
      newPlayers.push(createPlayer({ id: i, strikes: playerNumbers, score: 0 }))
    }
    context.commit('setPlayers', newPlayers)
  },
  setGameNumbers (context) {
    context.commit('setGameNumbers', state.game.cricket_numbers)
  },
  addPlayerScore (context, data) {
    if (state.game.game_over) return

    const player = data.player
    const strikeIndex = data.index
    const playerStrike = player.strikes[strikeIndex]
    const allPlayerIds = state.game.players.map(player => player.id)
    const closedStrikePlayerIds = state.game.players.map(function (player) {
      return player.strikes[strikeIndex].value >= 3 ? player.id : null
    })

    if (playerStrike.value < 3) {
      context.commit('addPlayerStrike', { player: player, strikeIndex: strikeIndex })
    } else {
      if (state.game.players.length > 2) {
        // cutthroat scoring
        state.game.players.forEach(function (player) {
          if (player.strikes[strikeIndex].value < 3) {
            context.commit('addPlayerScore', { player: player, strikeIndex: strikeIndex })
          }
        })
      } else {
        if (allPlayerIds.toString() !== closedStrikePlayerIds.toString()) {
          context.commit('addPlayerScore', { player: player, strikeIndex: strikeIndex })
        }
      }
    }

    // check if game is over
    const totalPlayerStrikes = state.game.players[player.id].strikes.reduce((total, strike) => total + strike.value, 0)
    // check closed as well as total
    if (totalPlayerStrikes > 20) {
      // player has everything closed
      const allPlayerScores = state.game.players.map(player => player.score)
      // scores are even
      if (new Set(allPlayerScores).size === 1) {
        state.game.game_over = true
      } else if (state.game.players.length > 2) {
        // check for lowest score
        let indexOfLowestScore = allPlayerScores.indexOf(Math.min(...allPlayerScores))

        // state.game.players.forEach(function (player, index) {
        state.game.players.forEach(function (player) {
          let totalStrikes = player.strikes.reduce((total, strike) => total + strike.value, 0)
          if (player.id === indexOfLowestScore && totalStrikes > 20) {
            state.game.game_over = true
            this.vueInsomnia().off()
          }
        })
      } else {
        // check for highest score
        const indexOfHighestScore = allPlayerScores.indexOf(Math.max(...allPlayerScores))
        if (player.id === indexOfHighestScore) {
          // game over
          state.game.game_over = true
          this.vueInsomnia().off()
        }
      }
    }
  }
}

const mutations = {
  initialiseStore (state) {
    // Check if the ID exists
    if (window.localStorage.getItem('game')) {
      // Replace the state object with the stored item
      this.replaceState(
        Object.assign(state.game, JSON.parse(localStorage.getItem('game')))
      )
    }
  },
  undo (state) {
    if (undoStates.length > 0) {
      state.game.players = JSON.parse(undoStates.pop())
    }
  },
  setGameOver (state, payload) {
    state.game.game_over = payload
  },
  setPlayers (state, payload) {
    state.game.players = payload
  },
  setGameNumbers (state, payload) {
    state.game.scores = payload
  },
  addPlayerStrike (state, payload) {
    const player = payload.player
    const strikeIndex = payload.strikeIndex
    state.game.players[player.id].strikes[strikeIndex].value++
  },
  addPlayerScore (state, payload) {
    const player = payload.player
    const strikeIndex = payload.strikeIndex
    state.game.players[player.id].score += player.strikes[strikeIndex].key
  }
}

const plugins = [ store => {
  store.subscribe((mutation, { game }) => {
    // Store the state object as a JSON string
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(game))
    // console.log(mutation.type)
    // console.log(mutation.payload)
  })
  store.subscribeAction((action, state) => {
    // store strikes for undo
    // TODO: only store if mark or score
    if (action.type === 'addPlayerStrike' || action.type === 'addPlayerScore') {
      // console.log(action)
      if (state.game.game_over) return
      undoStates.push(JSON.stringify(state.game.players))
    }
  })
}]

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins
})
